import React from "react";
import { Row, Col, Modal, Button, Form } from "@themesberg/react-bootstrap";
import { useState } from "react";

const ModalVerificationDialog = ({ cb, ...props }) => {
  const [reason, setReason] = useState("");
  // 0 => HIDE | 1 => NO SURAT | 2 => REVISI
  const [formMode, setFormMode] = useState(0);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={props.onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Verifikasi?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {formMode != 0 ? (
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>{formMode == 1 ? 'NO SURAT' : 'Alasan'}</Form.Label>
              <Form.Control
                type="text"
                placeholder={formMode == 1 ? 'masukkan no surat' : "masukkan alasan revisi"}
                value={reason || ""}
                required
                onChange={(e) => {
                  setReason(e.target.value);
                }}
                autoFocus
              />
            </Form.Group>
            <Row className="justify-content-end">
              <Col xs="auto">
                <Button variant="success" onClick={() => cb(formMode, reason)}>
                  Simpan
                </Button>
              </Col>
              <Col xs="auto">
                <Button variant="warning" onClick={() => setFormMode(0)}>
                  Batal
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <Row className="justify-content-center">
            <Col xs="auto">
              <Button variant="success" onClick={() => setFormMode(1)}>
                Setujui
              </Button>
            </Col>
            <Col xs="auto">
              <Button variant="warning" onClick={() => setFormMode(2)}>
                Revisi
              </Button>
            </Col>
            <Col xs="auto">
              <Button variant="danger" onClick={() => cb(3, "")}>
                Tolak
              </Button>
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalVerificationDialog;
